import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { selectSearchQuery } from '../../../selectors/searchState';
import { SEARCH, SEARCH_ACTIONS, SEARCH_ORIGINS } from '../../../tracking/trackerActions';
import { getUsageTracker } from '../../../utils/usage-tracker/index';
import { ResultIcon } from '../ResultIcon';
import ResultDescription from './ResultDescription';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ENDPOINT_RESULTS_SECTION = 'endpoint-results-section';
export const SUBMIT_FORM_OPTION_TOP = 'option-to-submit-search-top';
export const SUBMIT_FORM_OPTION_BOTTOM = 'option-to-submit-search-bottom';
const ResultOptionContainer = styled.div.withConfig({
  displayName: "ResultOption__ResultOptionContainer",
  componentId: "sc-2tcwd-0"
})(["padding:32px 12px 32px 0;display:flex;align-items:center;justify-content:space-between;"]);
const ResultOption = ({
  result,
  exitSearch
}) => {
  const query = useSelector(selectSearchQuery);
  const {
    pathname
  } = useLocation();
  const onResultClick = useCallback(event => {
    // exit from the search modal if click doesn't open in a new tab and link is on the current page
    if (!event.ctrlKey && !event.metaKey && `/${result.link}`.includes(pathname)) {
      exitSearch();
    }
    getUsageTracker().track(SEARCH, {
      action: SEARCH_ACTIONS.RESULT_SELECTED,
      origin: SEARCH_ORIGINS.DROPDOWN_SEARCH,
      searchTerm: query,
      link: `/${result.link}`
    });
  }, [exitSearch, pathname, query, result.link]);
  return /*#__PURE__*/_jsxs(ResultOptionContainer, {
    "data-test-id": "search-result",
    children: [/*#__PURE__*/_jsx(ResultDescription, {
      onClick: onResultClick,
      result: result,
      query: query
    }), /*#__PURE__*/_jsx(ResultIcon, {
      badge: result.badge
    })]
  });
};
export default ResultOption;